import axios from 'axios';
import Config from '@/Config';
import { parseJSON } from '@/Utils/JsonUtility';
import Log from '@/Utils/Log';

axios.defaults.transformResponse = [parseJSON];

class PerformanceMarketingApiClient {
    constructor(apiKey) {
        const apiClient = axios.create({
            baseURL: Config.http.performanceMarketing,
            headers: {
                'X-Api-Key': apiKey,
            },
        });

        // always parse error response to json
        apiClient.interceptors.response.use(
            response => {
                return this.mapResponse(response);
            },
            error => {
                // handling of json response when Axios is expecting Blob
                error.response = this.mapErrorResponse(error.response);

                if (error.response?.data instanceof Blob
                    && error.response?.data?.type === 'application/json') {
                    return new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onload = () => {
                            error.response.data = JSON.parse(reader.result);
                            this.tagAndLogError(error);
                            resolve(Promise.reject(error));
                        };
                        reader.onerror = () => {
                            reject(error);
                        };
                        reader.readAsText(error.response.data);
                    });
                }

                this.tagAndLogError(error);
                return Promise.reject(error);
            },
        );

        return apiClient;
    }

    tagAndLogError(error) {
        if (error && typeof error === 'object') {
            error._rollbarContext = error._rollbarContext || {};
            error._rollbarContext.area = 'adfound';
        }

        // Array of error messages that should not be logged to Rollbar
        // "already exists" - Prevent logging of duplicate name errors
        const ignoredErrorTitles = [
            'already exists',
        ];

        const errorMessage = error?.response?.data?.errors?.name?.[0] || '';
        const shouldIgnoreError = ignoredErrorTitles.some(ignoredTitle =>
            errorMessage.includes(ignoredTitle),
        );

        if (shouldIgnoreError) {
            return;
        }

        Log.error(error);
    }

    mapResponse(response) {
        const data = response.data?.data;
        if (data?.items) {
            data.pagedItems = data.items;
        }

        return response;
    }

    mapErrorResponse(response) {
        const errors = response?.data?.errors;
        if (!errors) {
            return response;
        }

        if (errors.general?.[0]) {
            response.data.message = errors.general[0];
        }

        if (Object.keys(errors).length && !response.data.message) {
            if (typeof response.data.data === 'object') {
                response.data.data.errors = { ...response.data.data.errors, errors };
            }
            else {
                response.data.data = { errors };
            }
        }

        return response;
    }
}
export default PerformanceMarketingApiClient;